var _regeneratorRuntime = require("/home/runner/work/anozon-blog/anozon-blog/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/anozon-blog/anozon-blog/node_modules/@babel/runtime/helpers/asyncToGenerator");

/*! clipboard-copy. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */

/* global DOMException */
module.exports = clipboardCopy;

function makeError() {
  return new DOMException('The request is not allowed', 'NotAllowedError');
}

function copyClipboardApi(_x) {
  return _copyClipboardApi.apply(this, arguments);
}

function _copyClipboardApi() {
  _copyClipboardApi = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(text) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (navigator.clipboard) {
              _context.next = 2;
              break;
            }

            throw makeError();

          case 2:
            return _context.abrupt("return", navigator.clipboard.writeText(text));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _copyClipboardApi.apply(this, arguments);
}

function copyExecCommand(_x2) {
  return _copyExecCommand.apply(this, arguments);
}

function _copyExecCommand() {
  _copyExecCommand = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(text) {
    var span, selection, range, success;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // Put the text to copy into a <span>
            span = document.createElement('span');
            span.textContent = text; // Preserve consecutive spaces and newlines

            span.style.whiteSpace = 'pre';
            span.style.webkitUserSelect = 'auto';
            span.style.userSelect = 'all'; // Add the <span> to the page

            document.body.appendChild(span); // Make a selection object representing the range of text selected by the user

            selection = window.getSelection();
            range = window.document.createRange();
            selection.removeAllRanges();
            range.selectNode(span);
            selection.addRange(range); // Copy text to the clipboard

            success = false;

            try {
              success = window.document.execCommand('copy');
            } finally {
              // Cleanup
              selection.removeAllRanges();
              window.document.body.removeChild(span);
            }

            if (success) {
              _context2.next = 15;
              break;
            }

            throw makeError();

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _copyExecCommand.apply(this, arguments);
}

function clipboardCopy(_x3) {
  return _clipboardCopy.apply(this, arguments);
}

function _clipboardCopy() {
  _clipboardCopy = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(text) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return copyClipboardApi(text);

          case 3:
            _context3.next = 15;
            break;

          case 5:
            _context3.prev = 5;
            _context3.t0 = _context3["catch"](0);
            _context3.prev = 7;
            _context3.next = 10;
            return copyExecCommand(text);

          case 10:
            _context3.next = 15;
            break;

          case 12:
            _context3.prev = 12;
            _context3.t1 = _context3["catch"](7);
            throw _context3.t1 || _context3.t0 || makeError();

          case 15:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 5], [7, 12]]);
  }));
  return _clipboardCopy.apply(this, arguments);
}